import {
  technicalContents,
  fundamentalContents,
  extraContents,
} from "./contentDetails";
import { getStars } from "../../Stars";
import { Popover } from "react-bootstrap";
import { projectPrimaryColor } from "../../../generalConfigs";

/**
 * This function returns an popover to be showed when hover an indicator
 * @param {Object} popoverConfigs - Props about a popover that will be show
 * @returns JSX Element.
 */
export function getIndicatorPopoverDetails(popoverConfigs) {
  if (popoverConfigs.contentId === undefined) {
    return <div></div>;
  }
  let popoverDetails = getPopoverTextDetails(popoverConfigs);
  return (
    <Popover style={{ borderRadius: 15, margin: 0, zIndex: 999 }}>
      <div className="animated-fast fadeInDown">
        <Popover.Header
          as="h3"
          style={{
            borderTopLeftRadius: 15,
            borderTopRightRadius: 15,
            backgroundColor: projectPrimaryColor,
            color: "white",
          }}
        >
          <i style={{ marginRight: 4 }}>{popoverDetails.icon}</i>
          {popoverDetails.title}
        </Popover.Header>
        <Popover.Body>
          <p>
            <span>{popoverDetails.description}</span>
          </p>
          <p>
            <span className="tx-semibold">Confiabilidade: </span>
            {getStars(popoverDetails.reliability, 5)}
            <br />
            <span className="tx-semibold">Indicado para: </span>
            <span>{popoverDetails.period}</span>
          </p>
        </Popover.Body>
      </div>
    </Popover>
  );
}

/**
 * Define popoverText according to the selected category and id.
 */
const getPopoverTextDetails = (popoverConfigs) => {
  switch (popoverConfigs.contentCategory) {
    case 0:
      return technicalContents.find(
        (item) => item.id === popoverConfigs.contentId
      );
    case 1:
      return fundamentalContents.find(
        (item) => item.id === popoverConfigs.contentId
      );
    case 2:
      return extraContents.find((item) => item.id === popoverConfigs.contentId);
    default:
      return null;
  }
};
